import './Sobre.css';

const Sobre = () => {

    return (
        <section className="sobre">
            <article className="sobre__quemSomos">
                {/* Avatar com ícone */}
                
                <h3 className="sobre__quemSomos--titulo">
                    <div className="sobre__quemSomos--icone">
                        <i className="bi bi-people"></i>
                    </div>
                    Quem somos
                </h3>            
                    <p className="sobre__quemSomos--texto">Um grupo de pessoas dedicado ao estudo da Doutrina Espírita. Nosso maior objetivo é o aprendizado sobre espiritualidade com base nas Obras Básicas e Obras Complementares da Doutrina Espírita utilizando estes estudos para aprimorar os conhecimentos e divulgação dos mesmos através deste site.</p>

                    <div className="sobre__quemSomos--contato"><a className="sobre__quemSomos--link" href="#">📧 contato@viverespirita.com.br</a>
                    </div>
            </article>        

            <article className="sobre__reunioes">

                <h3 className="sobre__reunioes--titulo">
                    <div className="sobre__reunioes--icone">
                        <i className="bi bi-book"></i>
                    </div>
                    Estudos online
                </h3>
                
                    <dl className="sobre__reunioes--lista">
                        <dt className="sobre__reunioes--lista---titulo">Estudos sobre a Doutrina Espírita</dt>
                            <dd className="sobre__reunioes--lista---item">📅 Todos os Domingos</dd>
                            <dd className="sobre__reunioes--lista---item">⏰ 20:00 horas</dd>
                            <dd className="sobre__reunioes--lista---item"> 
                                <a className="sobre__reunioes--lista---link" href='https://meet.google.com/xsd-gbmx-oid' target='blank'>🌐 Acesso através do Google Meet</a>
                            </dd>
                    </dl>
            </article>
            </section>

    );

}

export default Sobre;